import React from "react";
import ApplicationTable from "./ApplicationTable";

const FreeZoneApplication = () => {
  return (
    <div>
      <ApplicationTable />
    </div>
  );
};

export default FreeZoneApplication;
